import React, { useEffect, useState } from 'react';
import { Button, Spin } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { usePayroll } from '../../hooks/usePayroll';
import PayslipCard from '../../components/PayslipCard';
import { PayrollEntry } from '../../types';
import { customInstance } from '@/shared/api/mutator/custom-instance';

const PayslipDetailView: React.FC = () => {
  const { id, entryId } = useParams<{ id: string; entryId: string }>();
  const navigate = useNavigate();
  const { activePeriod, fetchPeriod } = usePayroll();
  const [entry, setEntry] = useState<PayrollEntry | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (id && entryId) {
      setLoading(true);
      Promise.all([
        fetchPeriod(Number(id)),
        customInstance<PayrollEntry>({ url: `/api/hr/payroll/entries/${entryId}`, method: 'GET' }),
      ])
        .then(([, e]) => setEntry(e))
        .finally(() => setLoading(false));
    }
  }, [id, entryId]);

  if (loading || !entry || !activePeriod) return <Spin className="p-6" />;

  return (
    <div className="p-6" style={{ maxWidth: 800 }}>
      <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(`/hr/payroll/${id}`)} style={{ marginBottom: 16 }}>
        Back
      </Button>
      <PayslipCard entry={entry} period={activePeriod} />
    </div>
  );
};

export default PayslipDetailView;
